/**
 * Top-nav links for the Vero Software site. Contact is rendered separately
 * as the navbar's call-to-action button.
 */

const routes = [
  { name: "Projects", route: "/projects" },
  { name: "History", route: "/history" },
];

export default routes;
